<template>
  <div>
    <Index v-if="show === 'index'" :companies="companies"
           :meta="meta" :query="query" @find="find()"
           @sendDeleteCompany="sendDeleteCompany"
           @pagination="pagination($event)"
           @createCompany="createCompany"
           @uploadFile="uploadFile($event)"
           @showCompany="showCompany($event)"/>

    <Show v-else @deletedCompany="show = 'index'"
          @toIndex="show = 'index'"
          @sendDeleteCompany="sendDeleteCompany"
          @editCompany="updateCompany"
          :provider="provider"/>

    <ModalDeleteCompany v-model="showModalDeleteProvider"
                        title="Excluir fornecedor"
                        :company="provider"
                        @sendDeleteModel="deleteCompany"/>

    <Modal v-model="showModalFormProvider">
      <span slot="header">{{ titleProviderForm }}</span>

      <FormProvider v-if="showModalFormProvider"
                    :provider="provider"
                    @cancel="showModalFormProvider = false"
                    @saved="savedCompany($event)"/>
    </Modal>
  </div>

</template>

<script>
  import Index from '@/components/providers/container/Index'
  import FormProvider from '@/components/providers/FormProvider'
  import Show from '@/components/providers/container/Show'
  import Modal from '../shares/specialTag/Modal'
  import ModalDeleteCompany from '@/components/company/ModalDeleteCompany'
  import GetAccount from '@/mixins/GetAccount'
  import ModelMapper from '@/mixins/ModelMapper'
  import handleSearchable from '@/models/handleSearchable'

  export default {
    components: { FormProvider, Index, Modal, ModalDeleteCompany, Show },
    computed: {
      companies() {
        return this.getModels || []
      }
    },
    created() {
      this.query.type = 'provider'
      this.order.push('name', 'asc')

      this.asyncTemplateSelect()
    },
    data() {
      return {
        nameModel: 'Company',
        provider: null,
        show: 'index',
        showModalDeleteProvider: false,
        showModalFormProvider: false,
        titleProviderForm: ''
      }
    },
    methods: {
      buildParams(pagination) {
        if (this.query.generic)
          this.query.generic = handleSearchable(this.query.generic)

        return this.$options.superMethods.buildParams.call(this, pagination)
      },
      createCompany() {
        this.provider = null
        this.titleProviderForm = 'Cadastrar fornecedor'
        this.showModalFormProvider = true
      },
      deleteCompany(provider) {
        this.asyncTemplateDelete(provider, {
          after: () => {
            this.showModalDeleteProvider = false
            this.show = 'index'
            this.find()
          }
        })
      },
      find() {
        this.asyncTemplateSelect()
      },
      savedCompany(provider) {
        this.find()
        this.showCompany(provider)
      },
      sendDeleteCompany(provider) {
        this.provider = provider
        this.showModalDeleteProvider = true
      },
      showCompany(provider) {
        this.showModalFormProvider = false
        this.provider = provider
        this.show = 'show'
      },
      updateCompany(provider) {
        this.titleProviderForm = 'Editar fornecedor'
        this.provider = provider
        this.showModalFormProvider = true
      },
      uploadFile(file) {
        const formData = new FormData()
        formData.append('file', file)

        this.axios.post('companies/upload',
          formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(() => this.$notify.add('Arquivo exportado com sucesso!'))
            .catch(e => this.$notify.addError(e))
            .finally(() =>  this.find())
      }
    },
    mixins: [GetAccount, ModelMapper],
    name: 'Container',
    superMethods: {
      buildParams: ModelMapper.methods.buildParams
    }
  }
</script>

<style scoped>

</style>
